// tslint:disable:no-trailing-whitespace
// tslint:disable:member-ordering
import { BaseEntity } from '../base-entity';
import { Feature } from './feature';
import { ProductType } from './product-type';

/// <code-import> Place custom imports between <code-import> tags

/// </code-import>

/// <module-code> Place module level code between <module-code> tags

/// </module-code>

export class ProductTypeFeatureMap extends BaseEntity  {

  /// <code> Place custom code between <code> tags
  
  /// </code>

  // Generated code. Do not place code below this line.
  /** Int32 key FK productType */
  productTypeId!: number;
  /** Int32 key FK feature */
  featureId!: number;
  /** Int32 */
  displayOrder!: number;
  /** FK featureId */
  feature!: Feature;
  /** FK productTypeId */
  productType!: ProductType;
}

